/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { jsmServicesEntryPoint } from '@jira/work-item__jsm-services/jsmServicesEntryPoint.entrypoint.tsx';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmServiceRequestEntrypointProps } from './JsmServiceRequest.entrypoint.types.tsx';

type JsmWorkItemServiceRequestEntryPointComponent = EntryPointComponent<
	Record<string, never>,
	{
		jsmServices: typeof jsmServicesEntryPoint;
	},
	JsmServiceRequestEntrypointProps,
	Record<string, never>
>;

export const jsmWorkItemServiceRequestEntryPoint: EntryPoint<
	JsmWorkItemServiceRequestEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<JsmWorkItemServiceRequestEntryPointComponent>(
		/* webpackChunkName: "async-jsm-work-item-service-request" */ './JsmServiceRequest.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (params: EntryPointRouteParams) => ({
		entryPoints: {
			jsmServices: {
				entryPoint: jsmServicesEntryPoint,
				entryPointParams: {
					issueKey: params.context.match.params?.issueKey ?? '',
					cloudId: params.tenantContext.cloudId,
					tenantContext: params.tenantContext,
				},
			},
		},
	}),
});
